import { Logo } from "@/components/Navbar";

export default function Footer() {
  return (
    <footer className="no-print bg-brand-ink-soft text-brand-line grain relative" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <Logo full />
          <p className="mt-4 text-sm text-brand-muted-light max-w-sm leading-relaxed">
            Spaces that inspire life. Thoughtfully crafted homes, priced with AI precision — from floor plan to final handover in weeks, not months.
          </p>
        </div>
        <div className="text-sm space-y-2">
          <p className="text-brand-accent uppercase tracking-[0.2em] text-xs mb-3">Studio</p>
          <p>Sarjapur, Bengaluru</p>
          <p>Mon – Sat · 10am – 7pm</p>
        </div>
        <div className="text-sm space-y-2">
          <p className="text-brand-accent uppercase tracking-[0.2em] text-xs mb-3">Contact</p>
          <p>info@homiininterior.com</p>
          <p>+91 63660 51735</p>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-brand-muted-light">© {new Date().getFullYear()} HOMIIN Interiors. All rights reserved.</div>
    </footer>
  );
}
